/**
 * Shared configuration for Next.js that can be used in both Edge Runtime and Node.js
 * This file should NOT use any Node.js specific APIs
 */

export const nextJsRoutes = [
  '/docs/',
  '/docs/community-projects/',
  '/docs/faq/',
  '/docs/faq/1gb-worth/',
  '/docs/faq/assemblies/',
  '/docs/faq/assembly-expiry/',
  '/docs/faq/charge-by-gb/',
  '/docs/faq/charge-by-minute/',
  '/docs/faq/chroot-user/',
  '/docs/faq/collaboration-seats/',
  '/docs/faq/custom-plans/',
  '/docs/faq/customffmpeg/',
  '/docs/faq/customize-progress/',
  '/docs/faq/discounts/',
  '/docs/faq/filtering/',
  '/docs/faq/filtering2/',
  '/docs/faq/filtering3/',
  '/docs/faq/firewall-allowlisting/',
  '/docs/faq/formats/',
  '/docs/faq/free-plan/',
  '/docs/faq/get-result-link-immediately/',
  '/docs/faq/hosting/',
  '/docs/faq/how-to-rename-files-during-export/',
  '/docs/faq/how-to-set-up-a-dropbox-app/',
  '/docs/faq/how-to-set-up-a-google-cloud-bucket/',
  '/docs/faq/how-to-set-up-an-amazon-s3-bucket/',
  '/docs/faq/how-to-set-up-digital-oceans-spaces/',
  '/docs/faq/how-we-store-assemblies/',
  '/docs/faq/limit-upload-size/',
  '/docs/faq/max-filesize/',
  '/docs/faq/md5-not-secure-hashing/',
  '/docs/faq/media-player/',
  '/docs/faq/meta-read-charges/',
  '/docs/faq/multi-file-uploads/',
  '/docs/faq/no-results/',
  '/docs/faq/notification-dev/',
  '/docs/faq/plan-limit-reached/',
  '/docs/faq/preset-resolutions/',
  '/docs/faq/pricing-example/',
  '/docs/faq/queues/',
  '/docs/faq/recommend-plan/',
  '/docs/faq/reserved-capacity/',
  '/docs/faq/reset-datavolume/',
  '/docs/faq/s3-safe/',
  '/docs/faq/signup-surprises/',
  '/docs/faq/slow-external-services/',
  '/docs/faq/template-mandatory-parameters/',
  '/docs/faq/template/',
  '/docs/faq/temporary-purge-sooner/',
  '/docs/faq/temporary-purge/',
  '/docs/faq/turbo-mode/',
  '/docs/faq/uppy-and-transloadit/',
  '/docs/faq/use-tlcdn/',
  '/docs/faq/user-tracking/',
  '/docs/faq/uuid/',
  '/docs/faq/validate-users/',
  '/docs/faq/watermarks/',
  '/docs/faq/why-charged-by-debuggable/',
  '/docs/getting-started/my-first-app/',
  '/docs/getting-started/saving-conversion-results/',
  '/docs/presets/audio/',
  '/docs/presets/video/',
  '/docs/robots/',
  '/docs/robots/audio-artwork/',
  '/docs/robots/audio-concat/',
  '/docs/robots/audio-encode/',
  '/docs/robots/audio-loop/',
  '/docs/robots/audio-merge/',
  '/docs/robots/audio-waveform/',
  '/docs/robots/azure-import/',
  '/docs/robots/azure-store/',
  '/docs/robots/backblaze-import/',
  '/docs/robots/backblaze-store/',
  '/docs/robots/cloudfiles-import/',
  '/docs/robots/cloudfiles-store/',
  '/docs/robots/cloudflare-import/',
  '/docs/robots/cloudflare-store/',
  '/docs/robots/digitalocean-import/',
  '/docs/robots/digitalocean-store/',
  '/docs/robots/document-autorotate/',
  '/docs/robots/document-convert/',
  '/docs/robots/document-merge/',
  '/docs/robots/document-ocr/',
  '/docs/robots/document-split/',
  '/docs/robots/document-thumbs/',
  '/docs/robots/downloading/',
  '/docs/robots/dropbox-import/',
  '/docs/robots/dropbox-store/',
  '/docs/robots/file-compress/',
  '/docs/robots/file-decompress/',
  '/docs/robots/file-filter/',
  '/docs/robots/file-hash/',
  '/docs/robots/file-preview/',
  '/docs/robots/file-read/',
  '/docs/robots/file-serve/',
  '/docs/robots/file-verify/',
  '/docs/robots/file-virusscan/',
  '/docs/robots/ftp-import/',
  '/docs/robots/ftp-store/',
  '/docs/robots/google-import/',
  '/docs/robots/google-store/',
  '/docs/robots/html-convert/',
  '/docs/robots/http-import/',
  '/docs/robots/image-bgremove/',
  '/docs/robots/image-describe/',
  '/docs/robots/image-facedetect/',
  '/docs/robots/image-generate/',
  '/docs/robots/image-merge/',
  '/docs/robots/image-ocr/',
  '/docs/robots/image-optimize/',
  '/docs/robots/image-resize/',
  '/docs/robots/meta-write/',
  '/docs/robots/minio-import/',
  '/docs/robots/minio-store/',
  '/docs/robots/pricing/',
  '/docs/robots/s3-import/',
  '/docs/robots/s3-store/',
  '/docs/robots/script-run/',
  '/docs/robots/sftp-import/',
  '/docs/robots/sftp-store/',
  '/docs/robots/speech-transcribe/',
  '/docs/robots/supabase-import/',
  '/docs/robots/supabase-store/',
  '/docs/robots/swift-import/',
  '/docs/robots/swift-store/',
  '/docs/robots/text-speak/',
  '/docs/robots/text-translate/',
  '/docs/robots/tigris-import/',
  '/docs/robots/tigris-store/',
  '/docs/robots/tus-store/',
  '/docs/robots/upload-handle/',
  '/docs/robots/video-adaptive/',
  '/docs/robots/video-concat/',
  '/docs/robots/video-encode/',
  '/docs/robots/video-merge/',
  '/docs/robots/video-ondemand/',
  '/docs/robots/video-subtitle/',
  '/docs/robots/video-thumbs/',
  '/docs/robots/vimeo-store/',
  '/docs/robots/wasabi-import/',
  '/docs/robots/wasabi-store/',
  '/docs/robots/youtube-store/',
  '/docs/robots/tlcdn-deliver/',
  '/docs/sdks/',
  '/docs/sdks/android-sdk/',
  '/docs/sdks/curl/',
  '/docs/sdks/go-sdk/',
  '/docs/sdks/heroku-addon/',
  '/docs/sdks/java-sdk/',
  '/docs/sdks/jquery-sdk/',
  '/docs/sdks/multipart-form/',
  '/docs/sdks/node-sdk/',
  '/docs/sdks/php-sdk/',
  '/docs/sdks/python-sdk/',
  '/docs/sdks/rails-sdk/',
  '/docs/sdks/rawtemplate/',
  '/docs/sdks/ruby-sdk/',
  '/docs/sdks/terraform-provider-transloadit/',
  '/docs/sdks/transloadify/',
  '/docs/sdks/transloaditkit/',
  '/docs/sdks/uppy/',
  '/docs/sdks/zapier/',
  '/docs/topics/assembly-execution-progress/',
  '/docs/topics/assembly-instructions/',
  '/docs/topics/assembly-variables/',
  '/docs/topics/dynamic-evaluation/',
  '/docs/topics/resize-strategies/',
  '/docs/topics/template-credentials/',
  '/docs/topics/templates/',
  '/docs/topics/use-parameter/',
  '/docs/topics/webhooks/',
  '/examples/buttons/',
  '/legal/imprint/',
  '/legal/privacy/',
  '/legal/team-policies/',
  '/legal/terms-of-service/',
  '/llms-full.txt',
  '/llms.txt',
  '/security/halloffame/',
  '/services/handling-uploads/',
  '/solutions/',
  '/solutions/construction/',
  '/solutions/ecommerce/',
  '/solutions/edtech/',
  '/solutions/event/',
  '/solutions/financial/',
  '/solutions/gaming/',
  '/solutions/government/',
  '/solutions/healthcare/',
  '/solutions/legal/',
  '/solutions/marketing/',
  '/solutions/media/',
  '/solutions/nonprofit/',
  '/solutions/real-estate/',
  '/solutions/social/',
  '/solutions/software/',
  '/solutions/travel/',
  '/support/',
  '/support/sla/',
] as const

export const nextJsAssetPaths = ['/_next/'] as const

// Re-export everything as a single config object as well
export const nextConfig = {
  nextJsRoutes,
  assetPaths: nextJsAssetPaths,
} as const
